import React from 'react';

import styled, { css } from 'styled-components';

import { AssetContainer } from '~/techstyle-shared/react-assets';
import {
  useBreakpoint,
  Carousel,
  mobile,
} from '~/techstyle-shared/react-components';
import { FormattedMessage } from '~/techstyle-shared/react-intl';

const Wrapper = styled.div`
  min-height: 380px;
  margin-bottom: 60px;
  text-align: center;
  padding: 0 5%;

  ${mobile`
    padding: 0;
  `};
`;

const ContentWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100%;
`;

const Content = styled.div``;

const Title = styled.div`
  padding-top: 24px;
  font-weight: bold;
  font-size: 30px;
  line-height: 37px;
  color: ${({ theme }) => theme.colors.textDefault};
`;

const TextCopy = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.fitAppTextCopy};
  margin: 20px auto;
  width: 36%;

  ${mobile`
    width: 100%;
    padding: 0 48px;
  `};
`;

const cellStyle = css`
  /*
   * A fixed height helps make sure the images, which come in different widths,
   * are displayed with same-sized profile circles and text
   */
  height: 150px;

  /*
   * Try to fit exactly 5 images side-by-side, but ensure that we don't make
   * them narrower than a width that would force the images within to overlap.
   */
  width: max(calc(100% / 5), 180px);
  text-align: center;

  ${mobile`
    height: 140px;

    /*
     * Try to show about two and a half images (the half hinting at the presence
     * of more in the absence of navigation arrows) before requiring user to
     * scroll to the right
     */
    width: max(calc(100% / 2.5), 100px);
  `};
`;

const Image = styled.img`
  max-height: 100%;
`;

const CarouselContainer = styled.div`
  margin: 25px 0;
`;

export default function FitAppPageMeet() {
  const { isMobile } = useBreakpoint();

  return (
    <Wrapper>
      <ContentWrapper>
        <Content>
          <Title>
            <FormattedMessage
              defaultMessage="Meet Our Trainers"
              id="fitness_app.section_7_title"
            />
          </Title>
          <TextCopy>
            <FormattedMessage
              defaultMessage="Our elite fitness professionals from across the country have created exclusive workouts - just for you!"
              id="fitness_app.section_7_copy"
            />
          </TextCopy>
        </Content>
        <CarouselContainer>
          <AssetContainer
            name={
              isMobile
                ? 'fitnessapp_content6_mobile'
                : 'fitnessapp_content6_desktop'
            }
            multi
          >
            {({ data }) => (
              <Carousel
                cellStyle={cellStyle}
                wrapAround={!isMobile}
                pageDots={false}
                prevNextButtons={!isMobile}
                contain
                freeScroll={isMobile}
                // The 3 comes from the offset it takes to put the first item on
                // the far left side of the screen when wrapAround is true and
                // we have 5 items onscreen.
                initialIndex={!isMobile ? 3 : undefined}
              >
                {(Array.isArray(data) ? data : [data]).map(
                  ({ imageFilename }) => (
                    <Image key={imageFilename} alt="" src={imageFilename} />
                  )
                )}
              </Carousel>
            )}
          </AssetContainer>
        </CarouselContainer>
      </ContentWrapper>
    </Wrapper>
  );
}
